import {
  computed,
} from 'vue';
import { searchTracksByUidAPI } from '@/api/getTags';
import { useCacheStore } from '@/store/cache';
import useRequest from '@/hooks/useRequest';

export default () => {
  const cacheStore = useCacheStore();
  const { request: searchTrackTagsRequest, isLoading: isLoadingTrackTags } = useRequest(searchTracksByUidAPI);
  const tagsUidKeys = computed(() => cacheStore.tagsUidKeys);

  const fetchTrackTags = async (trackUidList) => {
    cacheStore.cleanTagsCache();

    const [, res] = await searchTrackTagsRequest({
      in: trackUidList,
    });

    const trackTags = res.searchTracksByUid.map((item) => {
      const formatTagList = item.tags.map((tag) => ({
        label: tag.name || tag.tagGroup.name,
        rootType: tag.tagGroup?.tagRootId,
        tagGroupUid: tag.tagGroup?.tagGroupUid || tag.originUid || undefined,
        tagUid: tag.tagUid,
      }));

      return {
        trackUid: item.trackUid,
        formatTagList,
      };
    });

    cacheStore.saveTags('array', trackTags);
  };

  const handleTrackTags = (data = []) => {
    // console.log('data', data);
    const extractUids = data.map((item) => item.trackUid || item.track.trackUid);
    const filterExtractUids = extractUids.filter((id) => !tagsUidKeys.value.includes(id));
    if (filterExtractUids.length === 0) return;

    fetchTrackTags(filterExtractUids);
  };

  return {
    handleTrackTags,
    isLoadingTrackTags,
  };
};
